import * as devisConf from '@/configuration/devisConf';
import { CATEGORIE_DIVERS } from '@/configuration/produitConf';
import { AUCUN } from '@/configuration/optionBlocage/optionBlocage';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import { genererLigneBudget } from '@/services/recommandation/produitDevisManager';

function generationLigneCommande(ligneData, ligneCommandeOld = null) {
  const { produitEnfant } = ligneData;
  const ligneCommande = ligneCommandeOld ? ligneCommandeOld : genererLigneCommande();
  ligneCommande.etatObtenu = AUCUN;
  ligneCommande.dateEtatObtenu = null;
  ligneCommande.selected = false;
  ligneCommande.type = devisConf.NORMAL;

  // gestion du produit de la ligne
  ligneCommande.typeProduit = produitEnfant.supportCommercial.categorieVente;
  ligneCommande.produitId = produitEnfant.id;
  ligneCommande.numerique = produitEnfant.numerique;
  ligneCommande.produit = produitEnfant;
  ligneCommande.tauxTva = produitEnfant.tauxTva;
  ligneCommande.libelle = produitEnfant.libelle;
  if (ligneCommande.typeProduit === CATEGORIE_DIVERS) {
    ligneCommande.produit.produitDivers = produitEnfant.produitDivers;
  }

  // gestion des infos de la ligne
  ligneCommande.fournisseurId = ligneData.fournisseurId;
  ligneCommande.uniteVente = ligneData.uniteVente;
  ligneCommande.quantite = ligneData.quantite;
  ligneCommande.dateDebut = ligneData.dateDebut;
  ligneCommande.dateFin = ligneData.dateFin;
  ligneCommande.prixUnitaire = ligneData.prixUnitaire;
  ligneCommande.remise = parseFloat(ligneData.remise ? ligneData.remise : 0);
  ligneCommande.typeRemise = ligneData.typeRemise ? ligneData.typeRemise : devisConf.POURCENTAGE;
  if (ligneData.modeCalculHonoraire) {
    ligneCommande.modeCalculHonoraire = ligneData.modeCalculHonoraire;
  }

  // gestion des calculs
  ligneCommande.totalHt = ligneCommande.quantite * ligneCommande.prixUnitaire;
  ligneCommande.totalAvantRemise = ligneCommande.totalHt;

  return ligneCommande;
}

function generationLigneLocation(location, lignesCommandeOld) {
  const ligneOld = lignesCommandeOld.find(lc => lc.id === location.ligneCommandeId);
  const ligne = generationLigneCommande(location, ligneOld);
  ligne.lignesRemise = [location.budgetRemise];
  return ligne;
}

function generationLigneCommentaire(panneau, lignesCommandeOld) {
  const ligneOld = lignesCommandeOld.find(lc => lc.type === devisConf.COMMENTAIRE);
  const ligneCommentaire = ligneOld ? ligneOld : genererLigneCommande();
  ligneCommentaire.type = devisConf.COMMENTAIRE;
  ligneCommentaire.libelle = panneau.commentaire;
  return ligneCommentaire;
}

export function generationLignesCommandesMedia(panneau, budget, lignesCommandeOld) {
  const {
    location, tlpe, honoraires, honoraireFraisTraitement,
  } = genererLigneBudget(panneau, budget);

  const lignesCommandes = [generationLigneLocation(location, lignesCommandeOld)];

  [tlpe, honoraires, honoraireFraisTraitement]
    .filter(item => item && item.prixUnitaire > 0)
    .forEach(item => {
      const ligneOld = lignesCommandeOld.find(lc => lc.id === item.ligneCommandeId);
      lignesCommandes.push(generationLigneCommande(item, ligneOld));
    });

  if (panneau.commentaire) {
    lignesCommandes.push(generationLigneCommentaire(panneau, lignesCommandeOld));
  }
  return lignesCommandes;
}

export function generationLignesCommandesHorsMedia(panneau, budget, lignesCommandeOld) {
  const { fraisTechnique } = genererLigneBudget(panneau, budget);
  if (!fraisTechnique || !(fraisTechnique.prixUnitaire > 0)) return [];

  const ligneOld = lignesCommandeOld.find(lc => lc.id === fraisTechnique.ligneCommandeId);
  return [generationLigneCommande(fraisTechnique, ligneOld)];
}
